import type { ReactElement } from 'react'
import type { DeviceMode } from '../utils/deviceMode'

interface DeviceModeToggleProps {
  mode: DeviceMode
  onModeChange: (mode: DeviceMode) => void
  className?: string
}

export function DeviceModeToggle({
  mode,
  onModeChange,
  className = '',
}: DeviceModeToggleProps): ReactElement {
  return (
    <fieldset
      aria-label="Device view size"
      className={`inline-flex items-center rounded-xl bg-gray-100 p-1 font-medium text-xs ${className}`}
    >
      <button
        type="button"
        onClick={() => onModeChange('auto')}
        aria-pressed={mode === 'auto'}
        title="Automatically adjust to screen size"
        className={`rounded-lg px-2.5 py-1.5 transition-colors ${
          mode === 'auto'
            ? 'bg-white text-gray-900 shadow-xs'
            : 'text-gray-600 hover:text-gray-900'
        }`}
      >
        Auto
      </button>
      <button
        type="button"
        onClick={() => onModeChange('mobile')}
        aria-pressed={mode === 'mobile'}
        title="Mobile view"
        className={`flex items-center gap-1 rounded-lg px-2.5 py-1.5 transition-colors ${
          mode === 'mobile'
            ? 'bg-white text-gray-900 shadow-xs'
            : 'text-gray-600 hover:text-gray-900'
        }`}
      >
        <span aria-hidden="true">📱</span>
        <span>Mobile</span>
      </button>
      <button
        type="button"
        onClick={() => onModeChange('desktop')}
        aria-pressed={mode === 'desktop'}
        title="Desktop view"
        className={`flex items-center gap-1 rounded-lg px-2.5 py-1.5 transition-colors ${
          mode === 'desktop'
            ? 'bg-white text-gray-900 shadow-xs'
            : 'text-gray-600 hover:text-gray-900'
        }`}
      >
        <span aria-hidden="true">💻</span>
        <span>Desktop</span>
      </button>
    </fieldset>
  )
}
